import { camelCase } from 'lodash-es';

const MISCELLANEOUS = {
  pageDataAid: 'statements',
  pageTitle: {
    text: 'Statements',
    dataAid: 'statements',
  },
};

const TAX_FILING = {
  componentDataAid: 'taxFiling',
  sectionTitle: {
    text: 'Tax filing documents',
  },
  elss: {
    title: {
      text: '80C ELSS statement',
      dataAid: 'elssStatement',
    },
  },
  mutualFund: {
    title: {
      text: 'Capital gains - Mutual funds',
      dataAid: 'mutualFunds',
    },
  },
  stocks: {
    title: {
      text: 'Capital gains - Stocks',
      dataAid: 'stocks',
    },
  },
};

const STOCKS_AND_OPTIONS = {
  componentDataAid: 'stocks',
  sectionTitle: {
    text: 'Stocks and F&O',
    dataAid: 'title',
  },
  contractNote: {
    title: {
      text: 'Contract note',
      dataAid: 'contractNote',
    },
  },
  profitAndLoss: {
    title: {
      text: 'P&L statement',
      dataAid: 'p&LStatements',
    },
  },
  transaction: {
    title: {
      text: 'Transactions',
      dataAid: 'transaction',
    },
  },
  ledger: {
    title: {
      text: 'Ledger',
      dataAid: 'ledger',
    },
  },
  dematHolding: {
    title: {
      text: 'Demat holdings',
      dataAid: 'dematHoldings',
    },
  },
};

const MUTUAL_FUND = {
  componentDataAid: 'mutualFunds',
  sectionTitle: {
    text: 'Mutual funds',
    dataAid: 'title',
  },
  portfolio: {
    title: {
      text: 'Portfolio statement',
      dataAid: 'portfolioStatement',
    },
  },
  transaction: {
    title: {
      text: 'Transactions',
      dataAid: 'transactions',
    },
    rightIconDataAid: 'right',
  },
};

const EMPTY_SCREEN = {
  title: {
    text: 'Statements',
    dataAid: 'statements',
  },
  landingHeader: {
    title: 'No statements yet',
    dataAid: 'noHoldings',
    subtitle: 'Start investing to view your portfolio statements',
  },
};

const STATEMENTS = {
  ...MISCELLANEOUS,
  TAX_FILING,
  MUTUAL_FUND,
  STOCKS_AND_OPTIONS,
  EMPTY_SCREEN,
};

export default STATEMENTS;
